const stats = [
    { value: "10,000+", label: "Strategies Created" },
    { value: "₹50Cr+", label: "Backtested Volume" },
    { value: "5+", label: "Broker Integrations" },
    { value: "99.9%", label: "Uptime" }
];

const brokers = [
    { name: "Zerodha", logo: "/zerodha-logo.svg" },
    { name: "Upstox", logo: "/upstox-logo.svg" },
    { name: "Angel One", logo: "/angel-logo.svg" },
    { name: "Dhan", logo: "/dhan-logo.svg" },
    { name: "Fyers", logo: "/fyers-logo.svg" }
];

const TrustSection = ({ className = "" }) => {
    return (
        <section className={`py-24 px-4 md:px-12 lg:px-20 ${className}`}>
            <div className="max-w-7xl mx-auto">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <span className="text-sm font-semibold text-primary uppercase tracking-wider">Built for India</span>
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading mt-3 mb-4">
                        <span className="text-base-content">Trusted by </span>
                        <span className="text-gradient-primary">Indian Traders</span>
                    </h2>
                    <p className="text-base-content/60 max-w-2xl mx-auto text-lg">
                        Join thousands of traders who are already using AI to make smarter investment decisions
                    </p>
                </div>

                {/* Stats Grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
                    {stats.map((stat, index) => (
                        <div
                            key={index}
                            className="text-center p-6 rounded-2xl bg-base-200/50 border border-base-300/50"
                        >
                            <div className="text-3xl md:text-4xl font-bold text-gradient-primary font-heading mb-2">
                                {stat.value}
                            </div>
                            <div className="text-base-content/60 text-sm font-medium">
                                {stat.label}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Broker Integrations */}
                <div className="text-center">
                    <p className="text-sm text-base-content/50 mb-6 uppercase tracking-wider font-medium">
                        Integrated with leading Indian brokers
                    </p>
                    <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
                        {brokers.map((broker, index) => (
                            <div
                                key={index}
                                className="flex items-center justify-center h-12 px-4 opacity-60 hover:opacity-100 transition-opacity cursor-pointer"
                                title={broker.name}
                            >
                                {/* Placeholder text for broker names - replace with actual logos */}
                                <span className="text-xl font-bold text-base-content/70 font-heading">{broker.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrustSection;
